<template src="./template.html"></template>

<script>
  import { mapMutations, mapState, mapGetters } from 'vuex'

  export default {
    name: 'CartAddressHeader',
    props: { type: String },
    computed: {
      ...mapState('cart', ['isGuest']),
      ...mapGetters('deliveryAddress', {
        DeliveryAddressIsPending: 'isPending',
      }),
      ...mapGetters('invoiceAddress', {
        InvoiceAddressIsPending: 'isPending',
      }),
      storeType() {
        return this.snakeToPascal(this.type)
      },
    },
    methods: {
      ...mapMutations('modal', {
        setModalVisibility: 'SET_VISIBILITY',
        setModalType: 'SET_TYPE',
      }),
      showAddressBook(e) {
        e.preventDefault()
        this.setModalType(this.storeType)
        this.setModalVisibility()
      },
    },
  }
</script>
